import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation:
      require('../public/locales/en/translation.json')
  },
  ms: {
    translation:
      require('../public/locales/ms/translation.json')
  }
}

const whitelist = ['en', 'ms'];

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    detection: {
      order: ['querystring', 'localStorage'],
      lookupQuerystring: 'lng',
      lookupLocalStorage: 'i18next',
      caches: ['localStorage']
    },
    resources,
    lng: localStorage.getItem("i18next") || 'en',
    fallbackLng: whitelist,
    keySeparator: false,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    react: {
      useSuspense: false
    }
  });

export default i18n;
